import { render, staticRenderFns } from "./detail-warranty-status.vue?vue&type=template&id=0ed98544&"
import script from "./detail-warranty-status.vue?vue&type=script&lang=js&"
export * from "./detail-warranty-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports